// extracted by mini-css-extract-plugin
module.exports = {"WithdrawalCases":"ServiceCounterCard_WithdrawalCases__1BWiO","Tit":"ServiceCounterCard_Tit__22_qO","Desc":"ServiceCounterCard_Desc__A5rSk"};